<template>
  <TermsPage type="jobLocation" name="Site" :slug="$route.params.slug" />
</template>
